import { db } from "../config";
import { collection, getDocs, query, where, orderBy } from "firebase/firestore";
import { IndicationRecord } from "./indications.types";

export class IndicationsService {
  private indicationsRef = collection(db, "users_indications");

  /**
   * Retorna a lista de indicações do usuário logado
   */
  async getMyIndications(usernameSlug: string): Promise<IndicationRecord[]> {
    const q = query(
      this.indicationsRef,
      where("referrerSlug", "==", usernameSlug),
      orderBy("createdAt", "desc"),
    );

    const snapshot = await getDocs(q);

    return snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })) as IndicationRecord[];
  }
}

export const indicationsService = new IndicationsService();
